/**************************************************
 * Nombre:       Sostenibilidad_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import logo from "../../../Recursos/logo_rojo.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";

const Adicional_Contenido = ({item}) => {
    const {sCell} = useResponsive()
    const [arrContenido, setArrContenido] = useState([])

    useEffect(() => {

        setArrContenido([])
        if (item.parrafosImgs) {
            setArrContenido(item.parrafosImgs)
        }

    }, [item]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start',}}>
                    <Grid
                        container

                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={6}
                    >

                        {arrContenido.map((it, index) => {
                            return (
                                <Grid
                                    container
                                    direction={index % 2 ? 'row' : 'row-reverse'}
                                    justifyContent={'flex-start'}
                                    alignItems={'center'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    spacing={4}
                                >

                                    <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                        <Grid
                                            container
                                            justifyContent={'flex-start'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}
                                            spacing={2}
                                        >

                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                                <Typography sx={{
                                                    fontSize: 24,
                                                    fontWeight: 800,
                                                    color: theme.palette.primary.main,
                                                    textAlign: sCell ? 'center' : 'left'
                                                }}>

                                                    {it.nombre}
                                                </Typography>
                                            </Grid>

                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                                <Typography sx={{textAlign: 'justify'}}>
                                                    {it.descripcion}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 6, md: 6}}
                                          sx={{justifyContent: 'center', mt: sCell ? 3 : 0}}>
                                        <img src={it.img ? it.img : logo} width={'100%'} height={'auto'}
                                             style={{borderRadius: 10}}/>
                                    </Grid>

                                </Grid>
                            )
                        })}


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Adicional_Contenido